import { useCallback, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Left, Right } from '@linktivity/link-icons';
import { Menu } from '@linktivity/link-ui';
// import { ROUTE_PATH } from '@link/gds-share/constants/path';
import { useStore } from '@link/supplier/stores';

import styles from './sidebar.module.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const { auth } = useStore();
  // 侧边导航是否收起，收起后把整块宽度压到 0，把画面让给日历
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => !prev);
  }, []);

  return (
    <aside className={clsx(styles.sidebar, { [styles.collapsed]: collapsed })}>
      <button
        type="button"
        className={styles.toggle}
        onClick={toggleCollapsed}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        aria-expanded={!collapsed}
      >
        {collapsed ? (
          <Right width={16} height={16} />
        ) : (
          <Left width={16} height={16} />
        )}
      </button>
      <div className={styles.nav}>
        <div className={styles.inner}>
          {!auth.loading && (
            <Menu className={styles.menu} accordion>
              <Menu.MenuItem
                label={t('layouts.sidebar.allotmentSetting')}
                to="setting"
              />
              <Menu.MenuItem
                label={t('layouts.sidebar.allotmentCalendar')}
                to="calendar"
              />
              <Menu.MenuItem
                label={t('layouts.sidebar.allotmentException')}
                to="exception"
              />
              {auth.isLinkAdmin && (
                <>
                  <Menu.MenuItem
                    label={t('layouts.sidebar.allotmentSegmentId')}
                    to="segmentId"
                  />
                  <Menu.MenuItem
                    label={t('layouts.sidebar.allotmentOtaGroup')}
                    to="otaGroup"
                  />
                  <Menu.MenuItem
                    label={t('layouts.sidebar.allotmentBackend')}
                    to="backend"
                  />
                </>
              )}
            </Menu>
          )}
        </div>
      </div>
    </aside>
  );
};
const ObserverSidebar = observer(Sidebar);
export default ObserverSidebar;
